"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widthInRange = exports.parse = exports.multiply = exports.subtract = exports.add = void 0;
var DEFAULT = {
  minWidth: 104,
  maxWidth: 560
};

var parse = function parse(x) {
  x = x.toString();
  var value = parseFloat(x);
  var unit = x.replace(value, '');
  return {
    value: value,
    unit: unit
  };
};

exports.parse = parse;

var validate = function validate(x, y) {
  var unitX = parse(x).unit;
  var unitY = parse(y).unit;

  if (unitX && unitY && unitX !== unitY) {
    console.error('invalid operation, units should be same');
    return false;
  }

  return true;
};

var add = function add(x, y) {
  if (!validate(x, y)) return;
  var unit = parse(x).unit;
  var value = parse(x).value + parse(y).value;
  return value + unit;
};

exports.add = add;

var subtract = function subtract(x, y) {
  if (!validate(x, y)) return;
  var unit = parse(x).unit;
  var value = parse(x).value - parse(y).value;
  return value + unit;
};

exports.subtract = subtract;

var multiply = function multiply(x, y) {
  if (!validate(x, y)) return;
  var unit = parse(x).unit;
  var value = parse(x).value * parse(y).value;
  return value + unit;
};

exports.multiply = multiply;

var widthInRange = function widthInRange(width) {
  var minWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT.minWidth;
  var maxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT.maxWidth;
  if (!width) return width;

  var _parse = parse(width),
      parsedWidth = _parse.value,
      unit = _parse.unit;

  if (parsedWidth < minWidth) parsedWidth = minWidth;else if (parsedWidth > maxWidth) parsedWidth = maxWidth;
  return parsedWidth + unit;
};

exports.widthInRange = widthInRange;